import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-string-table-input',
    templateUrl: './string-table-input.component.html',
    styleUrls: [
        './string-table-input.component.scss'
    ]
})

export class StringTableinputComponent implements OnInit, OnChanges {
    @Input() name: string = "";
    @Input() label: string = "";
    @Input() selectionTitle: string = "";
    @Input() form: FormGroup = null;
    @Input() columnList: {name: string, title: string, label: string}[] = [];
    @Input() predefinedStringTable: string[][] = [];
    @Output() changeTableEvt: EventEmitter<string[][]> = new EventEmitter();

    stringTable: string[][] = [];

    constructor() { }
    ngOnChanges(changes: SimpleChanges): void {
        console.log("CHANGES");;console.dir(changes)
        if(changes.predefinedStringTable){
            this.stringTable = changes.predefinedStringTable.currentValue;
            console.log("new string table: "); console.dir(this.stringTable);
        }
    }

    ngOnInit() { 
        this.stringTable = this.predefinedStringTable;
    }

    addRow(){
        this.stringTable.push(
            this.columnList.map(col=>{
                console.log("adding column: ");console.dir(col);
                return this.form.controls[col.name].value
            })
        );
        console.log("table");console.dir(this.stringTable);
        this.changeTableEvt.emit(this.stringTable);
    }

    dropRow(row){
        const index = this.stringTable.indexOf(row);
        this.stringTable.splice(index, 1);
        this.changeTableEvt.emit(this.stringTable);
    }
}